/** Org URLs, built from ROUTES so the patterns and the links cannot drift. */
import { ROUTES } from "@/lib/constants";

export const orgRoute = (slug: string) => ROUTES.ORG.replace(":slug", encodeURIComponent(slug));
export const orgManageRoute = (slug: string, tab?: string) =>
  ROUTES.ORG_MANAGE.replace(":slug", encodeURIComponent(slug)) + (tab ? `?tab=${tab}` : "");
/** The shareable invite link (absolute, for copy/share). */
export const orgJoinUrl = (code: string, origin = window.location.origin) =>
  `${origin}${ROUTES.ORG_JOIN.replace(":code", encodeURIComponent(code))}`;
